import {
  searchAllMatters,
  searchMatters,
  buildMatterSearchRequest,
  getSearchMattersNextPageNumber,
  type SearchMattersInput,
} from "@/lib/data/requests/matters/search-matters";
import { queryKeys } from "@/lib/data/static/query-keys";
import { getSearchScope } from "@/lib/data/react-query/search/scope";

export const searchMattersQueryOptions = (input: SearchMattersInput) => ({
  queryKey: [
    queryKeys.matters,
    "search",
    "list",
    getSearchScope(),
    "v4",
    buildMatterSearchRequest(input),
  ],
  queryFn: ({ signal }: { signal: AbortSignal }) =>
    searchMatters(input, signal, "list"),
});

export const searchMattersCountQueryOptions = (input: SearchMattersInput) => ({
  queryKey: [
    queryKeys.matters,
    "search",
    "count",
    getSearchScope(),
    "v4",
    buildMatterSearchRequest(input, "count"),
  ],
  queryFn: ({ signal }: { signal: AbortSignal }) =>
    searchMatters(input, signal, "count"),
});

export const searchMattersInfiniteQueryOptions = (
  input: SearchMattersInput,
) => ({
  queryKey: [
    queryKeys.matters,
    "search",
    "infinite",
    "v4",
    getSearchScope(),
    buildMatterSearchRequest(input),
  ],
  initialPageParam: 1,
  queryFn: ({
    pageParam,
    signal,
  }: {
    pageParam: number;
    signal: AbortSignal;
  }) => searchMatters({ ...input, pageNumber: pageParam }, signal),
  getNextPageParam: getSearchMattersNextPageNumber,
});

export const searchAllMattersQueryOptions = (input: SearchMattersInput) => ({
  queryKey: [
    queryKeys.matters,
    "search-all",
    "v4",
    getSearchScope(),
    buildMatterSearchRequest(input),
  ],
  queryFn: ({ signal }: { signal: AbortSignal }) =>
    searchAllMatters(input, signal),
});
